import React from 'react';
import NavigationHeader from '../components/NavigationHeader';
import HomeHero from '../components/HomeHero';
import ProgramsComparison from '../components/ProgramsComparison';
import TechnologySummary from '../components/TechnologySummary';
import WhyOakham from '../components/WhyOakham';
import StadiumActivities from '../components/StadiumActivities';
import AlumniSection from '../components/AlumniSection';
import Footer from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';
import { homeHeroImage, activityImages } from '../siteData';

// Static program data (IDs and slugs for routing)
const programsData = [
  { id: "clinic", slug: "clinic", color: "green", icon: "Trophy", priceFrom: "£1,895", available: true },
  { id: "aston-villa", slug: "aston-villa", color: "claret", icon: "Shield", priceFrom: "£1,895", available: true }
];

const HomePage = () => {
  const { language } = useLanguage();
  
  // Translate hero data
  const heroData = {
    backgroundImage: homeHeroImage,
    badge: getTranslation(language, 'hero.badge'),
    title: getTranslation(language, 'hero.title'),
    subtitle: getTranslation(language, 'hero.subtitle'),
    ctaButtons: [
      { text: getTranslation(language, 'hero.exploreProgramsBtn'), type: "primary", link: "#programs" },
      { text: getTranslation(language, 'hero.viewPricesBtn'), type: "secondary", link: "/prices" }
    ]
  };

  // Activity data with images
  const activitiesData = {
    stadiumVisits: [
      { name: "Wembley Stadium", image: activityImages.wembley },
      { name: "Premier League Stadiums", image: activityImages.premierLeague }
    ]
  };

  return (
    <div className="min-h-screen">
      <NavigationHeader />
      <HomeHero data={heroData} />
      <ProgramsComparison programs={programsData} />
      {/* AlumniSection hidden until player permissions are obtained */}
      {/* <AlumniSection /> */}
      <TechnologySummary />
      <WhyOakham data={{}} />
      <StadiumActivities data={activitiesData} />
      {/* Testimonials section removed until real customer feedback is available */}
      <Footer />
    </div>
  );
};

export default HomePage;